import type { PokemonType } from './type';

export const MOVE_DAMAGE_CLASS_STATUS = 1;
export const MOVE_DAMAGE_CLASS_PHYSICAL = 2;
export const MOVE_DAMAGE_CLASS_SPECIAL = 3;

export type MoveDamageClass =
  | typeof MOVE_DAMAGE_CLASS_STATUS
  | typeof MOVE_DAMAGE_CLASS_PHYSICAL
  | typeof MOVE_DAMAGE_CLASS_SPECIAL;

export interface Move {
  id: number;
  name_ja: string;
  name_en: string;
  // 技のポケモンタイプID
  type: PokemonType;
  accuracy: number;
  power: number;
  // ダイマックス技の威力（設定されない技もある）
  dynamax_power?: number;
  // Z技の力（設定されない技もある）
  z_power?: number;
  damage_class_number: MoveDamageClass;
  min_renzoku: number;
  max_renzoku: number;
}
